// extracted by mini-css-extract-plugin
export default {"container":"JfF1EK"};